/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Rosy_Horse_LandInputs */

const en_shy_rosy_horse_land = /** @type {(inputs: Shy_Rosy_Horse_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No segments available for this attribute`)
};

const de_shy_rosy_horse_land = /** @type {(inputs: Shy_Rosy_Horse_LandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Segmente für dieses Merkmal verfügbar`)
};

/**
* | output |
* | --- |
* | "No segments available for this attribute" |
*
* @param {Shy_Rosy_Horse_LandInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_rosy_horse_land = /** @type {((inputs?: Shy_Rosy_Horse_LandInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Rosy_Horse_LandInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_rosy_horse_land(inputs)
	return de_shy_rosy_horse_land(inputs)
});